import React from 'react'
import history from '../../containers/History'
import styles from './NotFoundPage.css'
import DashboardIcon from 'static/images/icons/poll.svg'

const NotFoundPage = props => {
  const handleRouteToDashboard = () => {
    history.push('/dashboard')
  }
  return (
    <div data-page="not-found-page" className={styles.NotFoundPage}>
      <h1>404</h1>
      <h2>Sorry.</h2>
      <p>Looks like something went wrong.</p>
      <p>Head back to the Dashboard.</p>
      <button className={styles.dashboardBtn} onClick={handleRouteToDashboard}>
        <DashboardIcon />
        Dashboard
      </button>
    </div>
  )
}

export default NotFoundPage



// WEBPACK FOOTER //
// ./src/legacy/pages/NotFoundPage/NotFoundPage.jsx